import config from '@/modules/config/functions/config';
import { QueryClient } from '@tanstack/react-query';

/**
 * Get a new QueryClient instance
 * @returns query client
 */
export default function getQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        networkMode: 'always',
        staleTime(query) {
          // don't stale if the query has errors
          if (query.state.error) return 0;
          return config('misc.defaultQueryStaleTime', 0);
        },
        retry: config('misc.defaultQueryRetryCount', 3),
      },
      mutations: {
        retry: config('misc.defaultMutationRetryCount', 3),
      },
    },
  });
}
